<button mat-button [matMenuTriggerFor]="menu">{{'languageMenuTitle' | transloco}}</button>
<mat-menu #menu="matMenu">
  <button (click)="setLanguage($event)" value="en" mat-menu-item>{{ 'englishMenuItem' | transloco}}</button>
  <button (click)="setLanguage($event)" value="es" mat-menu-item>{{'spanishMenuItem' | transloco}}</button>
</mat-menu>